import { forwardRef } from 'react';
import { cn } from './utils/cn';

export interface SectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  action?: React.ReactNode;
}

export const SectionHeader = forwardRef<HTMLDivElement, SectionHeaderProps>(
  ({ title, action, className, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex items-center justify-between',
          'pb-2 border-b border-border-default',
          className
        )}
        {...props}
      >
        <h3 className="text-[11px] font-bold uppercase tracking-wider text-text-secondary">
          {title}
        </h3>
        {action && <div>{action}</div>}
      </div>
    );
  }
);

SectionHeader.displayName = 'SectionHeader';
